let testimonialSlider = {
  slider: null,
  dotsContainer: null,
  totalSlides: 0,
  currentIndex: 0,
  isScrolling: false,
  scrollAmount: 344,
  originalSlides: [],
  isExtending: false,

  init: function () {
    this.slider = document.getElementById('testimonialSlider');
    this.dotsContainer = document.getElementById('sliderDots');
    if (!this.slider) return;

    const cards = Array.from(
      this.slider.querySelectorAll('.testimonial-card')
    );

    this.originalSlides = cards.map(card => card.cloneNode(true));
    this.totalSlides = cards.length;

    this.scrollAmount = window.innerWidth <= 768 ? 296 : 344;

    // Add buffer slides on both ends (2x the original set)
    this.prependSlides();
    this.prependSlides();
    this.extendSlidesForward();
    this.extendSlidesForward();
    
    // Set initial scroll position in the middle buffer zone
    this.slider.scrollLeft = 2 * this.totalSlides * this.scrollAmount;

    this.createDots();
    this.setupEventListeners();
    this.updateCurrentIndex();
  },

  createDots: function () {
    this.dotsContainer.innerHTML = '';
    for (let i = 0; i < this.totalSlides; i++) {
      const dot = document.createElement('div');
      dot.className = 'dot';
      dot.dataset.index = i;
      this.dotsContainer.appendChild(dot);
    }
  },

  updateDots: function () {
    const dots = this.dotsContainer.querySelectorAll('.dot');
    dots.forEach((dot, index) => {
      dot.classList.toggle('active', index === this.currentIndex);
    });
  },

  extendSlidesForward: function () {
    const fragment = document.createDocumentFragment();
    this.originalSlides.forEach(slide => {
      fragment.appendChild(slide.cloneNode(true));
    });
    this.slider.appendChild(fragment);
  },

  prependSlides: function () {
    const fragment = document.createDocumentFragment();
    // Create in reverse to maintain order when prepending
    for (let i = this.originalSlides.length - 1; i >= 0; i--) {
      fragment.insertBefore(
        this.originalSlides[i].cloneNode(true),
        fragment.firstChild
      );
    }
    this.slider.insertBefore(fragment, this.slider.firstChild);
  },

  checkAndExtend: function () {
    if (this.isExtending) return;
    
    const currentScroll = this.slider.scrollLeft;
    const maxScroll = this.slider.scrollWidth - this.slider.clientWidth;
    
    // More generous thresholds to extend before user gets close
    const forwardThreshold = maxScroll - (this.scrollAmount * this.totalSlides);
    const backwardThreshold = this.scrollAmount * this.totalSlides;
    
    // Check if scrolling forward (near the end)
    if (currentScroll >= forwardThreshold) {
      this.isExtending = true;
      requestAnimationFrame(() => {
        this.extendSlidesForward();
        this.isExtending = false;
      });
    }
    
    // Check if scrolling backward (near the beginning)
    if (currentScroll <= backwardThreshold) {
      this.isExtending = true;
      const oldScrollLeft = currentScroll;
      
      requestAnimationFrame(() => {
        this.prependSlides();
        // Adjust scroll position instantly to maintain visual position
        this.slider.scrollLeft = oldScrollLeft + (this.totalSlides * this.scrollAmount);
        this.isExtending = false;
      });
    }
  },

  scrollToSlide: function (index, animated = true) {
    const targetScroll = index * this.scrollAmount;

    this.slider.scrollTo({
      left: targetScroll,
      behavior: animated ? 'smooth' : 'auto',
    });
  },

  updateCurrentIndex: function () {
    const rawIndex = Math.round(
      this.slider.scrollLeft / this.scrollAmount
    );

    this.currentIndex = rawIndex % this.totalSlides;
    if (this.currentIndex < 0)
      this.currentIndex += this.totalSlides;

    this.updateDots();
  },

  setupEventListeners: function () {
    let scrollTimeout;
    let lastScrollLeft = this.slider.scrollLeft;
    
    this.slider.addEventListener('scroll', () => {
      // Only check extension if scroll position actually changed significantly
      const currentScrollLeft = this.slider.scrollLeft;
      if (Math.abs(currentScrollLeft - lastScrollLeft) > this.scrollAmount / 4) {
        this.checkAndExtend();
        lastScrollLeft = currentScrollLeft;
      }
      
      // Debounce index update
      clearTimeout(scrollTimeout);
      scrollTimeout = setTimeout(() => {
        this.updateCurrentIndex();
      }, 100);
    });

    this.dotsContainer.addEventListener('click', (e) => {
      if (!e.target.classList.contains('dot')) return;

      const targetIndex = parseInt(e.target.dataset.index);
      const currentScrollIndex = Math.round(this.slider.scrollLeft / this.scrollAmount);
      const currentActualIndex = currentScrollIndex % this.totalSlides;
      
      // Calculate closest path to target
      let offset = targetIndex - currentActualIndex;
      if (offset > this.totalSlides / 2) offset -= this.totalSlides;
      if (offset < -this.totalSlides / 2) offset += this.totalSlides;
      
      const targetScrollIndex = currentScrollIndex + offset;
      this.scrollToSlide(targetScrollIndex, true);
    });
  },

  next: function () {
    if (this.isScrolling) return;
    this.isScrolling = true;

    const nextIndex =
      Math.round(this.slider.scrollLeft / this.scrollAmount) + 1;

    this.scrollToSlide(nextIndex, true);

    setTimeout(() => {
      this.isScrolling = false;
    }, 500);
  },

  prev: function () {
    if (this.isScrolling) return;
    this.isScrolling = true;

    const prevIndex =
      Math.round(this.slider.scrollLeft / this.scrollAmount) - 1;

    this.scrollToSlide(prevIndex, true);

    setTimeout(() => {
      this.isScrolling = false;
    }, 500);
  },
};

// Global buttons
function scrollTestimonials(direction) {
  direction === 'next'
    ? testimonialSlider.next()
    : testimonialSlider.prev();
}

// Init
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () =>
    testimonialSlider.init()
  );
} else {
  testimonialSlider.init();
}